import React from 'react'

import { CollectionTitleDS } from '@src/components/blocks/collection-title-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { CollectionTitleLegacy } from './collection-title-legacy'

import type { CollectionTitleProps } from './collection-title.types'

export const CollectionTitle: React.FC<CollectionTitleProps> = props => {
  if (shouldUseDesignSystem()) {
    return <CollectionTitleDS {...props} />
  }

  return <CollectionTitleLegacy {...props} />
}
